<sm-table class="width100p height100p" [data]="table"></sm-table>